"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var material_1 = require("@mui/material");
var List_1 = require("@mui/material/List");
var ListItem_1 = require("@mui/material/ListItem");
var Suggestion_1 = require("./Suggestion");
var SuggestionService_1 = require("../services/SuggestionService");
var react_infinite_scroll_hook_1 = require("react-infinite-scroll-hook");
var Toast_1 = require("../shared/utilities/Toast");
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
var originalSuggestions = [
    {
        id: '0',
        name: "Jeff Green",
        nameAbbr: "JG",
        title: "September 14, 2016 2:00 PM",
        body: React.createElement("div", null,
            "I think the website is really dark and could use more light, maybe we can add a few new things like ",
            React.createElement("br", null),
            " Blog ",
            React.createElement("br", null),
            " eLearning website ",
            React.createElement("br", null),
            " eCommerce website  ",
            React.createElement("br", null),
            " Portfolio website  ",
            React.createElement("br", null),
            " Resume website  ",
            React.createElement("br", null),
            " Nonprofit website  ",
            React.createElement("br", null),
            " Event website  ",
            React.createElement("br", null),
            " Business website."),
    },
    {
        id: '1',
        name: "Darlene McNally",
        nameAbbr: "DM",
        title: "September 22, 2016 2:00 PM",
        body: React.createElement("div", null,
            "The website is really cool ",
            React.createElement("br", null),
            " I bet a really cool guy made it!"),
    },
];
function Suggestions() {
    var _a = Toast_1.default(), showErrorMessage = _a.showErrorMessage, showSuccessMessage = _a.showSuccessMessage;
    var _b = React.useState(false), ready = _b[0], setReady = _b[1];
    var _c = React.useState([]), suggestions = _c[0], setSuggestions = _c[1];
    var _d = React.useState(0), pageNumber = _d[0], setPageNumber = _d[1];
    var _e = React.useState(10), pageSize = _e[0], setPageSize = _e[1];
    var _f = React.useState(true), hasNextPage = _f[0], setHasNextPage = _f[1];
    var _g = React.useState(false), loading = _g[0], setLoading = _g[1];
    var _h = React.useState(false), showRead = _h[0], setShowRead = _h[1];
    var getNextPage = function () {
        console.log('getting next page');
        setLoading(true);
        var newPageNumber = pageNumber + 1;
        setPageNumber(newPageNumber);
        SuggestionService_1.default.GetSuggestions(newPageNumber, pageSize, showRead).then(function (response) {
            if (response.Suggestions.length == 0) {
                setHasNextPage(false);
            }
            setSuggestions(suggestions.concat(response.Suggestions));
            setLoading(false);
        });
    };
    var handleIsReadChanged = function (id, value) {
        setReady(false);
        SuggestionService_1.default.UpdateSuggestion(id, value).then(function (response) {
            if (response == null) {
                showErrorMessage('Unknown error occured updating suggestion!');
            }
            else {
                if (showRead == false && value == true) {
                    var newSetSuggestions = __spreadArray([], suggestions);
                    var index = newSetSuggestions.map(function (suggestion) { return suggestion.SuggestionId; }).indexOf(id);
                    newSetSuggestions.splice(index, 1);
                    console.log(newSetSuggestions);
                    setSuggestions(__spreadArray([], newSetSuggestions));
                }
                else {
                    var newSetSuggestions = __spreadArray([], suggestions);
                    var index = newSetSuggestions.map(function (suggestion) { return suggestion.SuggestionId; }).indexOf(id);
                    var item = __assign(__assign({}, suggestions[index]), { IsRead: value });
                    newSetSuggestions[index] = item;
                    setSuggestions(__spreadArray([], newSetSuggestions));
                }
            }
            setReady(true);
        });
    };
    React.useEffect(function () {
        SuggestionService_1.default.GetSuggestions(pageNumber, pageSize, showRead).then(function (response) {
            if (response != null && response.Suggestions != null && response.error == null) {
                setSuggestions(response.Suggestions);
                setReady(true);
            }
            else {
                showErrorMessage('Unknown error occured getting suggestions!');
            }
        });
    }, []);
    var handleShowReadChange = function (e) {
        setReady(false);
        setShowRead(e.target.checked);
        setPageNumber(0);
        SuggestionService_1.default.GetSuggestions(0, pageSize, e.target.checked).then(function (response) {
            if (response.Suggestions.length == 0) {
                console.log('setting next page false');
                setHasNextPage(false);
            }
            else {
                setHasNextPage(true);
            }
            setSuggestions(response.Suggestions);
            setReady(true);
        });
    };
    var _j = react_infinite_scroll_hook_1.default({
        loading: loading,
        hasNextPage: hasNextPage,
        onLoadMore: getNextPage,
        disabled: false,
        rootMargin: '0px 0px 100px 0px',
    }), sentryRef = _j[0], rootRef = _j[1].rootRef;
    return (React.createElement(Box_1.default, { component: "main", sx: { flexGrow: 1, p: 3, marginBottom: '40px' } },
        React.createElement(DrawerHeader, null),
        !ready &&
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true })),
        ready &&
            React.createElement(React.Fragment, null,
                React.createElement(material_1.FormGroup, null,
                    React.createElement(material_1.FormControlLabel, { sx: { paddingLeft: '15px' }, control: React.createElement(material_1.Checkbox, { checked: showRead, onChange: handleShowReadChange }), label: "Show Already Read" })),
                React.createElement(List_1.default, { sx: { width: '100%', bgcolor: 'background.paper' } },
                    suggestions.map(function (suggestion) { return (React.createElement(Suggestion_1.default, { id: suggestion.SuggestionId, firstName: suggestion.SuggestionUser == null ? '' : suggestion.SuggestionUser.FirstName, lastName: suggestion.SuggestionUser == null ? '' : suggestion.SuggestionUser.LastName, title: suggestion.SuggestionSubject, body: suggestion.SuggestionDescription, documentLocation: suggestion.DocumentLocation, isRead: suggestion.IsRead, handleIsReadChanged: handleIsReadChanged })); }),
                    (loading || hasNextPage) && (React.createElement(ListItem_1.default, { ref: sentryRef, style: { justifyContent: 'center' } },
                        React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true })))))));
}
exports.default = Suggestions;
//# sourceMappingURL=Suggestions.js.map